import type { Ref } from 'vue';
import { computed } from 'vue';

import type { IContextQueryResult } from '@modules/core/services/query/types';
import type { EStaticPageName } from '@modules/static-pages/enums';
import { useRestClient } from '@modules/core/services/api';
import { useContextQuery } from '@modules/core/services/query';
import useStaticPageConfig from '@modules/static-pages/composables/useStaticPageConfig';

import type {
  IStaticPage,
} from '../types';
import {
  STATIC_PAGES_GET_QUERY_KEY,
  STATIC_PAGES_GET_URL,
} from '../constants';

export default function useStaticPageQuery(
  page: Ref<EStaticPageName | undefined>,
  language?: Ref<string | undefined>,
  isEnabled?: Ref<boolean>,
): IContextQueryResult<
    IStaticPage
  > {
  const { fetchGet } = useRestClient();
  const { getStaticPagePermission } = useStaticPageConfig();

  return useContextQuery<
    IStaticPage
  >({
    queryKey: [STATIC_PAGES_GET_QUERY_KEY, page, language],
    queryFn: ({ signal }) => fetchGet<IStaticPage>(
      STATIC_PAGES_GET_URL,
      {
        signal,
        permission: page.value ? getStaticPagePermission(page.value) : undefined,
        urlParams: {
          page: page.value,
        },
        queryParams: language?.value
          ? {
              language: language.value,
            }
          : undefined,
      },
    ),
    enabled: computed(() => !!page.value && (!isEnabled || isEnabled.value)),
  });
}
